import React from "react";
import "../Assessts/Styles/AboutUs.scss";
import AUs from "../Assessts/Images/AboutUs/Aboutus.png";
import SS from "../Assessts/Images/AboutUs/SS.svg";
import AC from "../Assessts/Images/AboutUs/AC.svg";
import VD from "../Assessts/Images/AboutUs/VD.svg";
import YOI from "../Assessts/Images/AboutUs/YOI.svg";
import { useMatch } from "react-router-dom";
const SAboutus = () => {
  const Details = [
    {
      Tittle: "WHO WE ARE",
      COntent: (
        <>
          <b>North South Foundation</b> is a volunteer-driven, non-profit
          organization that supports meritorious students from economically
          challenged backgrounds across India through educational scholarships.
        </>
      ),
    },
    {
      Tittle: "WHAT WE DO",
      COntent:
        "The foundation offers scholarships for high school, undergraduate, and professional education programs, including engineering, medicine, and other career-oriented courses. Scholarships are awarded based on academic merit and financial need.",
    },
    {
      Tittle: "Program Overview",
      COntent:
        "Students receive continued financial support until graduation, subject to maintaining academic performance. The program is funded through donations, with local chapters managing outreach, application review, and student verification to ensure fairness and transparency.",
    },
  ];

  const Details2 = [
    { Icon: SS, Count: "11,000+", Name: "Students Supported" },
    { Icon: AC, Count: "24+", Name: "Active Chapters" },
    { Icon: VD, Count: "100%", Name: "Volunteer Driven" },
    { Icon: YOI, Count: "21", Name: "Years of Impact" },
  ];
  return (
    <>
      <div className="p-5 dflex gap-5 SAU-Content">
        <img src={AUs} alt="About Us" />
        <div>
          {Boolean(useMatch("AboutUs")) && (
            <div
              className="Web-MainHeading"
              style={{ justifyContent: "flex-start" }}
            >
              About Us
            </div>
          )}
          {Details.map((item) => (
            <>
              <div className="Web-SubHeading mt-4 mb-1">{item.Tittle}</div>
              <p style={{ textAlign: "justify" }}>{item.COntent}</p>
            </>
          ))}
        </div>
      </div>
      <div className="dflex gap-5 JCCenter alignitems SAU-Count">
        {Details2.map((item) => (
          <div
            className="dflex flexd-column gap-2 JCCenter alignitems"
            style={{ textAlign: "center" }}
          >
            <span>
              {" "}
              <img src={item?.Icon} alt={item.Name} />
            </span>
            <b>{item?.Count}</b>
            <div className="Web-SubHeading">{item?.Name}</div>
          </div>
        ))}
      </div>
    </>
  );
};
export default SAboutus;
